export enum MapKeyCiudad {
  CODIGO = 'codigo',
  NOMBRE = 'nombre',
  DEPARTAMENTO_CODIGO = 'departamentoCodigo',
  PERMITIDA = 'permitida',
}
